import React, { Component } from 'react';
import {
  Checkbox,
  Form,
  Grid,
  Header,
  Icon,
  Segment,
} from 'semantic-ui-react';
import { SketchPicker } from 'react-color';
import Utils from '../Utils.js';

let bgColors = ["#eeeeee", "#222222", "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"];
let fgColors = ["#eeeeee", "#222222", "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"];
let checkboxStyle = {
  marginTop: '5px',
  marginBottom: '5px',
}

class ColorSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fg: { r: 240, g: 240, b: 240, a: 1, },
      bg: { r: 40, g: 40, b: 40, a: 1, },
      capacities: this.props.capacities,
      textColor: 'auto',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ capacities: nextProps.capacities, });
  }

  textColor = (color) => {
    this.props.onTextColor(color);
    this.setState({
      textColor: color,
    });
  }

  fg = (color) => {
    this.props.onFg(color);
    this.setState({
      fg: color.rgb,
    });
  }

  bg = (color) => {
    this.props.onBg(color);
    this.setState({
      bg: color.rgb,
    });
  }

  render() {

    let columns = 4;
    if (!Utils.hasCapacity(this.state.capacities, 'fg_color')) {
      columns -= 2;
    }
    if (!Utils.hasCapacity(this.state.capacities, 'bg_color')) {
      columns -= 2;
    }
    if (Utils.hasCapacity(this.state.capacities, 'text_color')) {
      columns += 2;
    }
    if (columns === 0) {
      return null; // nothing to configure!
    }

    return (
      <Grid columns={1} stackable>
        <Grid.Column>
          <Segment>
            <Header as='h2' textAlign='left'>
              <Icon name='pencil'/>
              <Header.Content>Colors</Header.Content>
              <Header.Subheader>Finally, select some colors.</Header.Subheader>
            </Header>
          </Segment>
        </Grid.Column>

        <Grid.Row columns={columns}>
          {Utils.hasCapacity(this.state.capacities, 'bg_color') &&
            <Grid.Column verticalAlign='middle' textAlign='center' width={4}>
              <strong>Primary Color</strong>
            </Grid.Column>
          }
          {Utils.hasCapacity(this.state.capacities, 'bg_color') &&
            <Grid.Column>
              <Form.Field>
                <SketchPicker disableAlpha={true} presetColors={bgColors} color={this.state.bg} onChangeComplete={this.bg} />
              </Form.Field>
            </Grid.Column>
          }
          {Utils.hasCapacity(this.state.capacities, 'fg_color') &&
            <Grid.Column verticalAlign='middle' textAlign='center' width={4}>
              <strong>Text Color</strong>
            </Grid.Column>
          }
          {Utils.hasCapacity(this.state.capacities, 'fg_color') &&
            <Grid.Column>
              <Form.Field>
                <SketchPicker disableAlpha={true} presetColors={fgColors} color={this.state.fg} onChangeComplete={this.fg} />
              </Form.Field>
            </Grid.Column>
          }
          {Utils.hasCapacity(this.state.capacities, 'text_color') &&
            <Grid.Column verticalAlign='middle' textAlign='center' width={4}>
              <strong>Text Color</strong>
            </Grid.Column>
          }
          {Utils.hasCapacity(this.state.capacities, 'text_color') &&
            <Grid.Column verticalAlign='middle' textAlign='left'>
              <Checkbox style={checkboxStyle} radio onClick={() => { this.textColor('auto'); }} checked={this.state.textColor === 'auto'} label='Auto' /><br />
              <Checkbox style={checkboxStyle} radio onClick={() => { this.textColor('black'); }} checked={this.state.textColor === 'black'} label='Black' /><br />
              <Checkbox style={checkboxStyle} radio onClick={() => { this.textColor('white'); }} checked={this.state.textColor === 'white'} label='White' /><br />
            </Grid.Column>
          }
        </Grid.Row>
      </Grid>
    );
  }
}

export default ColorSelection;



// WEBPACK FOOTER //
// ./src/tool/ColorSelection.js